import { AuthorizationProvider } from '@frontend/authorization';
import { FeatureTarget } from '@frontend/functionality/types';
import { AccountStoreProvider, BlobStoreProvider, BrandingStoreProvider, DocumentStoreProvider, LicenseStoreProvider } from '@frontend/repository';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { Authentication } from './authentication/basic-authentication-wrapper/authentication.component';
import { DevIndicator } from './dev-indicator';
import { PlatformModalHost } from './modal/platform-modal-host/platform-modal-host.component';
import NoAccountMessage from './no-account-message';
import { useAppDispatch } from './redux/store';
import Resolver from './utils/resolver';

export const DefaultProviders = (props: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    return (
        <>
            <DocumentStoreProvider>
                <BlobStoreProvider>
                    <BrandingStoreProvider>
                        <BrowserRouter>
                            <Authentication>
                                <AccountStoreProvider noAccountsMessage={<NoAccountMessage />}>
                                    <AuthorizationProvider dispatch={dispatch}>
                                        <LicenseStoreProvider targets={[FeatureTarget.PLATFORM, FeatureTarget.API]}>
                                            <Resolver>
                                                <PlatformModalHost>{props.children}</PlatformModalHost>
                                            </Resolver>
                                        </LicenseStoreProvider>
                                    </AuthorizationProvider>
                                </AccountStoreProvider>
                            </Authentication>
                        </BrowserRouter>
                        <ToastContainer />
                    </BrandingStoreProvider>
                </BlobStoreProvider>
            </DocumentStoreProvider>
            <DevIndicator />
        </>
    );
};

export default DefaultProviders;
